import { buildApiUrl, getApiBaseCandidates } from "@/lib/apiBase";

export const resolveMediaUrl = (value?: string) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("data:")) return raw;

  const normalized = raw.replace(/\\/g, "/");

  // Determine if we are executing on the production domain environment.
  const isProdDomain = typeof window !== "undefined" && (
    window.location.hostname.includes("equipmentmarket.ng") ||
    window.location.hostname.includes("elra.gov.ng") ||
    (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1" && !window.location.hostname.startsWith("192.168."))
  );

  const isProdEnv = Boolean(import.meta.env.PROD || isProdDomain);

  if (/^https?:\/\//i.test(normalized)) {
    try {
      const parsed = new URL(normalized);
      const host = String(parsed.hostname || "").toLowerCase();
      
      const isOurAppHost = 
        host === "localhost" || 
        host === "127.0.0.1" || 
        (typeof window !== "undefined" && host === window.location.hostname.toLowerCase()) ||
        host.includes("equipmentmarket.ng") || 
        host.includes("elra.gov.ng");

      if (isOurAppHost) {
        if (isProdEnv) {
          // If we are on production site, convert any absolute path (including localhost/127.0.0.1 database records) 
          // directly to the production domain prefix.
          const pathname = parsed.pathname.startsWith("/uploads/") ? `/api${parsed.pathname}` : parsed.pathname;
          return `https://equipmentmarket.ng${pathname}${parsed.search || ""}`;
        }
        const base = getApiBaseCandidates()[0] || "";
        if (parsed.pathname.startsWith("/uploads/")) {
          return buildApiUrl(`/api${parsed.pathname}${parsed.search || ""}`, base);
        }
        return buildApiUrl(`${parsed.pathname}${parsed.search || ""}`, base);
      }
      return normalized;
    } catch {
      return normalized;
    }
  }

  // Handle relative path inputs on production vs local
  if (isProdEnv) {
    let cleanPath = normalized;
    if (cleanPath.startsWith("backend/uploads/")) {
      cleanPath = `/uploads/${cleanPath.slice("backend/uploads/".length)}`;
    } else if (cleanPath.startsWith("uploads/")) {
      cleanPath = `/${cleanPath}`;
    } else if (cleanPath.startsWith("/uploads/")) {
      cleanPath = `${cleanPath}`;
    } else if (cleanPath.endsWith("websitelogog.png") || cleanPath.endsWith("footerlogo.png") || cleanPath.endsWith("favicon.ico") || cleanPath.endsWith("placeholder.svg")) {
      // Keep static frontend assets on the root domain path directly
      cleanPath = `/${cleanPath.replace(/^\/+/, "")}`;
    } else if (!cleanPath.startsWith("/api/")) {
      cleanPath = `/api/${cleanPath.replace(/^\/+/, "")}`;
    }
    // Prepend production domain prefix to prevent any localhost fallbacks
    return `https://equipmentmarket.ng${cleanPath}`;
  }

  const base = getApiBaseCandidates()[0] || "";

  if (normalized.startsWith("/api/uploads/")) {
    return buildApiUrl(normalized, base);
  }

  if (normalized.startsWith("/uploads/")) {
    return buildApiUrl(`/api${normalized}`, base);
  }

  if (normalized.startsWith("uploads/")) {
    return buildApiUrl(`/api/${normalized}`, base);
  }

  if (normalized.startsWith("backend/uploads/")) {
    return buildApiUrl(`/api/uploads/${normalized.slice("backend/uploads/".length)}`, base);
  }

  return normalized;
};